import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PublicNavigationStateService {
  private readonly isHeroVisibleSubject = new BehaviorSubject<boolean>(true);

  readonly isHeroVisible$: Observable<boolean> =
    this.isHeroVisibleSubject.asObservable();

  get isHeroVisible(): boolean {
    return this.isHeroVisibleSubject.value;
  }

  setisHeroVisible(isActive: boolean): void {
    this.isHeroVisibleSubject.next(isActive);
  }
}
